import React from 'react';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

import { AdminPrompt } from '~/services/AccommodationService';

interface ShowPromptModalProps {
  open: boolean;
  onClose: () => void;
  prompt: AdminPrompt;
  onSetPrompt: (prompt: AdminPrompt) => void;
}

export default function GeneratedContentPromptModal({ open, onClose, prompt, onSetPrompt }: ShowPromptModalProps) {
  const handleSetPrompt = () => {
    onSetPrompt(prompt);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Generation Prompt</DialogTitle>
      <DialogContent>
        <Stack spacing={3}>
          <Box>
            <Typography variant="subtitle1" gutterBottom>
              Template
            </Typography>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
              {prompt.template}
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle1" gutterBottom>
              Examples
            </Typography>
            {prompt.examples?.map((example, index) => (
              <Typography key={index} variant="body2" sx={{ whiteSpace: 'pre-wrap', mb: 1 }}>
                {example}
              </Typography>
            ))}
          </Box>

          {prompt.variables && (
            <>
              {prompt.variables.abstain && (
                <Box>
                  <Typography variant="subtitle1" gutterBottom>
                    Abstain
                  </Typography>
                  <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                    {prompt.variables.abstain as string}
                  </Typography>
                </Box>
              )}
              {prompt.variables.voice && (
                <Box>
                  <Typography variant="subtitle1" gutterBottom>
                    Voice
                  </Typography>
                  <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                    {prompt.variables.voice as string}
                  </Typography>
                </Box>
              )}
            </>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSetPrompt} variant="contained" color="primary">
          Set as current prompt
        </Button>
      </DialogActions>
    </Dialog>
  );
}
